module.exports = __webpack_public_path__ + "img/53.52804139.png";